import { HTMLAttributes, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { usePopperTooltip } from 'react-popper-tooltip';
import * as S from './styles';
import 'react-popper-tooltip/dist/styles.css';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  message: string | ReactNode;
}

export function Tooltip({ message, children, ...rest }: Props) {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip(
    { placement: 'top', trigger: 'hover', delayShow: 200 },
    {
      modifiers: [
        { name: 'offset', options: { offset: [0, 4] } },
        { name: 'arrow', options: { padding: 8 } },
      ],
    }
  );

  return (
    <>
      <span ref={setTriggerRef} {...rest}>
        {children}
      </span>

      {visible &&
        createPortal(
          <S.Tooltip
            ref={setTooltipRef}
            {...getTooltipProps({ className: 'tooltip-container' })}
          >
            {message}
            <div {...getArrowProps({ className: 'arrow-wrapper' })}>
              <div className="arrow" />
            </div>
          </S.Tooltip>,
          document.body
        )}
    </>
  );
}
